import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as categoryApis from "../../utilities/apis/category"
import Layout from "../../components/Layout"

const Categories = () => {
  const navigate = useNavigate()
  const { token, permissions } = useSelector(state => state.user)
  const [categories, setCategories] = useState([])

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await categoryApis.deleteCategory(token, id)
      if (!response.status) throw new Error(response.message)

      setCategories((previous) => {
        const categories = previous.filter(x => x.id !== id)
        return [...categories]
      })
    } catch (error) {
    }
  }

  const getCategories = async () => {
    try {
      const response = await categoryApis.getCategories(token, "")
      if (!response.status) throw new Error(response.message)

      setCategories(response.categories)
    } catch (error) {
    }
  }

  useEffect(() => {
    getCategories()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Categories</p>
            {permissions["CREATE_CATEGORY"] && <Link to="/dashboard/category" className="btn btn-theme rounded-4">New</Link>}
          </div>

          <div className="border rounded-4">
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "50%" }} className="align-middle">Name</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle text-center">Products</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((row) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">{row.name}</td>
                      <td className="align-middle text-center">0</td>
                      <td className="align-middle text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["UPDATE_CATEGORY"] && <Link to={`/dashboard/category?id=${row.id}`}><i className="far fa-edit"></i></Link>}
                          {permissions["DELETE_CATEGORY"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Categories
